<template>
  <base-row v-bind="$props">
    <td>
      <div class="truncate max-w-xs">
        <Link
          v-if="hasRoute"
          :href="productShowRoute"
          class="uppercase font-semibold text-blue-600 hover:text-blue-600"
        >
          {{ item.name }}
        </Link>
        <span
          v-else
          class="text-blue-600 hover:text-blue-600"
        >
          {{ item.name }}
        </span>
      </div>
      <div
        v-if="item.sku"
        class="text-sm"
      >
        SKU: {{ item.sku }}
      </div>
    </td>
    <td>
      {{ item.quantity_total }}
    </td>
    <td>
      {{ item.quantity_available }}
    </td>
    <td>
      {{ item.unit_price ? _dollars(item.unit_price) : '' }}
    </td>
    <td>
      {{ item.categories.length > 0 ? item.categories[0] : '' }}
    </td>
    <td>
      {{ item.batch_count }}
    </td>
    <td>
      POS: {{ item.pos_last_synced_at ? _date(item.pos_last_synced_at) : '-' }}
      <br />
      eComm: {{ item.ecommerce_last_synced_at ? _date(item.ecommerce_last_synced_at) : '-' }}
    </td>
    <td>
      <basic-badge
        v-if="item.deleted_at"
        color="red"
      >
        Archived
      </basic-badge>
      <basic-badge
        v-else-if="item.is_published"
        color="green"
      >
        Published
      </basic-badge>
      <basic-badge
        v-else
        color="gray"
      >
        Draft
      </basic-badge>
    </td>
  </base-row>
</template>

<script>
import { Link } from '@inertiajs/vue3'
import TableRow from '@/Components/Table/TableRow'
import RowProps from '@/Components/Table/Mixins/RowProps'
import BasicBadge from '@/Components/Badges/BasicBadge.vue'
import _date from '@/Filters/Date'
import _percent from '@/Filters/Percent'
import _dollars from '@/Filters/Dollars'

export default {
  components: {
    'base-row': TableRow,
    Link,
    BasicBadge
  },

  mixins: [RowProps],

  props: {
    /**
     * A function that we can use to generate the URL to view a product. Returns a string that is a valid URL
     */
    showRoute: {
      type: Function,
      default: (item) => null
    }
  },

  computed: {
    /**
     * Returns the URL we can use to view a product
     */
    productShowRoute() {
      return this.showRoute(this.item)
    },

    /**
     * Returns true if this product has a valid URL to view a product
     * @returns {boolean}
     */
    hasRoute() {
      return this.productShowRoute !== null
    }
  },
  methods: {
    _date,
    _percent,
    _dollars
  }
}
</script>
